import React from 'react';
import PropTypes from 'prop-types';

// Components
import MapPanel from '../../../components/MapPanel';
import RoomStatusZone from '../../../components/RoomStatusZone';

// Constants
import { DEFAULT, AlertTypes } from '../../../constants';

/**
 * Whether every hub in a room is reporting, for the room's hub dot. Null for a
 * room with no hubs, which gets no dot: there is nothing to report on.
 */
const hubsConnected = (room) => {
  const hubs = (room.getHubs() ?? []).filter((hub) => hub.getIsActive() !== false);
  if (hubs.length === 0) return null;
  return hubs.every((hub) => hub.getIsConnected());
};

// Props: rooms, onRoomSelection, selectedRoom
export default class MapRoomView extends React.Component {

  render() {
    return (
      <MapPanel floorPlanImagePath={this.props.floorPlanImagePath} style={this.props.style}>
        {(mapScale) => this.props.rooms.map((room, index) => (
          <RoomStatusZone
            key={index}
            mapScale={mapScale}
            statusColor={room.getAlertStatus() ? room.getAlertStatus().getColor() : DEFAULT}
            isNormal={room.getAlertStatus()?.getDashboardStatus() === AlertTypes.NORMAL.getDashboardStatus()}
            hubsConnected={hubsConnected(room)}
            vertices={room.getVertices()}
            onClick={() => this.props.onRoomSelection(room)}
            isSelected={this.props.selectedRoom && this.props.selectedRoom.getID() === room.getID()}
            blinking={room?.getAlertStatus()?.getDashboardStatus() === AlertTypes.EMERGENCY.getDashboardStatus() && room?.getAlertUpdates()?.reverse()?.find(au => au.getAlertType()?.getDashboardStatus() === AlertTypes.EMERGENCY.getDashboardStatus() && au.isActive) != null}
          />
        ))}
      </MapPanel>
    );
  }
}

MapRoomView.propTypes = {
  rooms: PropTypes.array,
  floorPlanImagePath: PropTypes.string,
  onRoomSelection: PropTypes.func,
  selectedRoom: PropTypes.object,
  style: PropTypes.object
};
